import { Request, request } from '@factorin/rest';
import { Pagination } from '@factorin/domain';
import { store } from '@factorin/container.macro';


export interface DescisionFile {
    Kind: string;
    MediaType: string;
    Data: string;
    KindName: string;
    Size: number;
}

export interface Descision {
    Uid: string;
    EmitentName: string;
    ExchageOperatorName: string;
    OisName: string;
    Amount: number;
    IssuedDate: Date;
    BurnedDate: Date;
    Files: DescisionFile[];
}

export const DESCISIONS_PAGINATION_PATH = 'descisions';

export const descisions = {
    list: ({ query }: Request.Query<Pagination.Request>) => request<Pagination.List<Descision>>({
        basePath: store.getState().config.opermoduleUrl,
        apiPath: 'api/v1/public',
        method: 'GET',
        url: 'descisions',
        query,
    }),
};
